import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var CouponStatusRes;
export const CouponStatusTodo = createAsyncThunk('CouponStatus', async (data) => {
    console.log(data)
    try {
        const res = await axios({
            method: "Put",
            url: process.env.REACT_APP_API_URL + `coupon_status/${data.id}`,
            params:{
                "coupon_status" : data.status
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('user_token') }
        })
        return CouponStatusRes = res.data

    } catch (error) {
        return CouponStatusRes = error.response.data
    }
})
